import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

import { STRATEGIES_QUERY_KEY } from "./useStrategies";

export type DeleteStrategyVariables = {
  strategyId: string;
};

export function useDeleteStrategy() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<void, Error, DeleteStrategyVariables>({
    mutationFn: async ({ strategyId }) => {
      const { error } = await client.DELETE("/api/strategies/{strategy_id}", {
        params: { path: { strategy_id: strategyId } },
      });
      if (error !== undefined) {
        throw new Error(`Failed to delete strategy ${strategyId}`);
      }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: STRATEGIES_QUERY_KEY });
    },
  });
}
